(function () {
  var FLAG_KEY = 'shopping_vera';
  var DEPLOYMENT_KEY = 'client-iR81cflnCwB96fsp0HxbjqLSiJSqZW40';
  var CACHE_KEY = 'shopping_vera';
  var CACHE_TTL_MS = 86400000; // 24 hours
  var WIDGET_BASE = 'https://storage.googleapis.com/villoid-widget/';
  var ENV_KEY = 'villoid_widget_env';

  // Exposure is manual. With the SDK default (automaticExposureTracking: true) every
  // client.variant() read logs a $exposure, and fetchVariant() reads the flag on every page
  // load (cached path included), so every page view minted an "exposed" user, PDPs included
  // (SRM on shopping_vera, Asana 1218398085995704). Both arms are exposed on a search:
  //   - treatment: when Vera renders an answer on it (window.villoidFireVeraExposure, called by
  //     assets/vera-product-seen-chat.js on the widget's `inline_block_shown`, mode "search");
  //   - control: when its results are on screen, where treatment would mount Vera
  //     (watchControlSearch).
  var client = null;
  var fetched = false;
  var exposurePending = false;
  var exposed = false;
  // Variant that decided whether this page got the widget. Employees get it regardless of
  // assignment (shouldInject), so they are never exposed as control.
  var appliedVariant = null;

  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.ts > CACHE_TTL_MS) return null;
      return data.variant;
    } catch (e) {
      return null;
    }
  }


  function writeCache(variant) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ variant: variant, ts: Date.now() }));
    } catch (e) { }
  }


  // Vera inline search mount waits for main#MainContent .ns-results-container
  // (widget.js SEARCH_RESULTS_SELECTOR). Current Nosto search paints .ns-serp
  // / .ns-products-wrapper without that class, so the inline block never
  // appears and product_seen_chat cannot fire. Alias before the widget boots.
  // The widget's waiter only observes childList, not attributes, so after
  // adding the class we poke a comment node to wake it if it already missed
  // this mutation.
  var nostoAnchorWatching = false;

  function aliasNostoSearchRoot() {
    var main = document.querySelector('main#MainContent');
    if (!main || main.querySelector('.ns-results-container')) return;
    var root = main.querySelector('.ns-serp') || main.querySelector('.ns-products-wrapper');
    if (!root) return;
    root.classList.add('ns-results-container');
    var poke = document.createComment('vera-search-anchor');
    root.appendChild(poke);
    root.removeChild(poke);
  }

  function watchNostoSearchRoot() {
    if (nostoAnchorWatching) return;
    nostoAnchorWatching = true;
    aliasNostoSearchRoot();
    if (!document.body) return;
    new MutationObserver(aliasNostoSearchRoot).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function injectWidgets() {
    watchNostoSearchRoot();
    var env = localStorage.getItem(ENV_KEY);
    var filename = env === 'dev' ? 'widget_dev.js' : 'widget.js';
    var widgetScript = document.createElement('script');
    widgetScript.src = WIDGET_BASE + filename;
    document.body.appendChild(widgetScript);
  }


  // The Amplitude app embed boots on the window `load` event (ready ~50ms after it). On a slow phone `load`
  // comes more than 5s after DOMContentLoaded, and a plain 5s budget gave up before Amplitude existed: no
  // client, so the exposure was dropped and first-visit treatment users never got the widget. The budget
  // now only counts after `load`.
  function waitForAmplitude(callback) {
    var attempts = 0;
    (function check() {
      if (window.amplitude && window.amplitude.Identify) return callback();
      if (document.readyState === 'complete' && ++attempts > 50) return;  // timed out: fail closed
      setTimeout(check, 100);
    })();
  }


  // Once per page, for the server-assigned variant. A trigger that comes before fetch() has resolved is
  // remembered and fired once the allocation is there.
  function fireExposure() {
    if (exposed) return;
    if (client && fetched) {
      exposed = true;
      try { client.exposure(FLAG_KEY); } catch (e) {}
    } else {
      exposurePending = true;
    }
  }

  window.villoidFireVeraExposure = function () {
    if (appliedVariant === 'treatment') fireExposure();
  };

  // Same trigger the widget mounts Vera on: a non-empty `q` on `/` or `/search`, with the search results
  // root in main#MainContent (the widget waits for .ns-results-container, which aliasNostoSearchRoot adds
  // to the Nosto root). A search from the homepage renders in place (pushState), so the DOM is watched
  // rather than checked once.
  var SEARCH_RESULTS_ROOT = 'main#MainContent .ns-results-container, main#MainContent .ns-serp, main#MainContent .ns-products-wrapper';

  function isSearchPath() {
    return window.location.pathname === '/' || window.location.pathname === '/search';
  }

  function watchControlSearch() {
    if (!isSearchPath() || !document.body) return;  // a search anywhere else loads /?q= afresh
    function check() {
      var q = new URLSearchParams(window.location.search).get('q');
      if (!isSearchPath() || !q || !q.trim() || !document.querySelector(SEARCH_RESULTS_ROOT)) return false;
      fireExposure();
      return true;
    }
    if (check()) return;
    var observer = new MutationObserver(function () {
      if (check()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function fetchVariant(callback) {
    if (!window.Experiment) {
      console.warn('[villoid-widget] Amplitude Experiment SDK not available');
      callback(null);
      return;
    }
    try {
      client = window.Experiment.initializeWithAmplitudeAnalytics(
        DEPLOYMENT_KEY,
        { serverZone: 'EU', automaticExposureTracking: false }
      );
      client.fetch().then(function () {
        var result = client.variant(FLAG_KEY);
        fetched = true;
        callback(result && result.value ? result.value : 'control');
        if (exposurePending) {
          exposurePending = false;
          fireExposure();
        }
      }).catch(function (err) {
        console.warn('[villoid-widget] experiment.fetch() failed:', err);
        callback(null);
      });
    } catch (err) {
      console.warn('[villoid-widget] Experiment init failed:', err);
      callback(null);
    }
  }


  function isVilloidEmployee() {
    try {
      var email = window.__stylista && window.__stylista.customer && window.__stylista.customer.email;
      return typeof email === 'string' && email.toLowerCase().endsWith('@villoid.com');
    } catch (e) {
      return false;
    }
  }

  function shouldInject(variant) {
    return variant === 'treatment' || isVilloidEmployee();
  }

  function applyVariant(variant) {
    if (shouldInject(variant)) {
      injectWidgets();
    } else {
      watchControlSearch();
    }
  }

  function init() {
    try {
      var cached = readCache();

      if (cached) {
        appliedVariant = cached;
        applyVariant(cached);
        // Background refresh — only updates cache for next page load
        waitForAmplitude(function () {
          fetchVariant(function (fresh) {
            if (fresh) writeCache(fresh);
          });
        });
      } else {
        // Cache miss: wait for Amplitude then fetch
        waitForAmplitude(function () {
          fetchVariant(function (variant) {
            if (variant) {
              appliedVariant = variant;
              writeCache(variant);
              applyVariant(variant);
            }
            // null variant = error = fail closed
          });
        });
      }
    } catch (err) {
      console.warn('[villoid-widget] init failed:', err);
      // fail closed
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });
})();
